import store from '@/store'
import { getData } from '@core/utils/http/general'

// Lista de pagares
export const BecasAlumno = personafk => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 16,
    token: store.state.cuenta.session.token,
    personafk,
  }
  getData(paramsRequest, 'wsalumno')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
// more functions
export const alias = null
